import * as React from "react"
import { useToast } from "@/hooks/useToast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { Copy } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  // title/description are always plain strings in every toast() call in this
  // codebase (never JSX), so String() is enough to get copyable text back out
  // of either - no need for a DOM ref just to read back what we already have.
  const copyToastText = (title?: React.ReactNode, description?: React.ReactNode) => {
    const text = [title, description].filter(Boolean).map(String).join("\n")
    if (text) navigator.clipboard.writeText(text)
  }

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            {/* Toasts here stay on screen a very long time (TOAST_REMOVE_DELAY),
                so a long error/status message is worth letting someone actually
                copy - to paste into a support message, for instance - instead
                of retyping it by hand. Same hover-reveal treatment as
                ToastClose, offset left of it so the two never overlap. */}
            {(title || description) && (
              <button
                type="button"
                onClick={() => copyToastText(title, description)}
                aria-label="Copy"
                className="absolute right-8 top-1 rounded-[6px] p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-1 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600"
              >
                <Copy className="h-3.5 w-3.5" />
              </button>
            )}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
